import React, { useState, useEffect } from 'react';
import getLocal from '@/app/utils/getLocal';

export const useGetChatData = () => {
    const [loadChat, setLoadChat] = useState(false);
    const [payloadData, setPayloadData] = useState<any>({});
    const { locale } = getLocal();

    const NEXT_PUBLIC_MODY = process.env.NEXT_PUBLIC_MODY;

    const localSiteMap: Record<string, number> = {
        us: 1,
        ca: 2,
        au: 3,
        za: 4,
        uk: 5,
        eu: 6,
        de: 7,
        fr: 12,
        cn: 13,
        jp: 14,
    };

    const originPlayload = {
        $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
        type: 'AdaptiveCard',
        version: '1.3',
        body: [
            {
                type: 'TextBlock',
                text: 'Ready to try the ECOFLOW AI Assistant?',
                weight: 'bolder',
                style: 'heading',
            },
            {
                type: 'TextBlock',
                size: 'Medium',
                text: 'This assistant is designed solely to support your interactions with ECOFLOW products.',
            },
            {
                type: 'TextBlock',
                size: 'Medium',
                text: '⚠️Please note:',
                weight: 'bolder',
            },
            {
                type: 'TextBlock',
                wrap: true,
                text: '🔹 AI-generated responses are for reference only and do not constitute professional advice or official commitments.\n\n🔹 For important decisions or safety-related issues, please consult human support or official documentation.\n\n🔹 Do not enter any personal or sensitive information, such as ID numbers, bank details, or content related to politics or religion.\n\n🔹 The information you enter during interaction may be used for AI model optimization and service improvement, in full compliance with applicable privacy regulations.',
                spacing: 'medium',
            },
            {
                type: 'TextBlock',
                text: '🔹 For more details, see [Privacy Policy](https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html) and [AI Assistant Service Disclaimer](https://account.ecoflow.com/agreement/en-us/ECOFLOW-AI-Assistant-Service-Disclaimer.html)',
            },
            {
                type: 'Input.Toggle',
                size: 'small',
                id: '{"Id":"e4bdf7cb-995e-ec11-8f8f-000d3a31376e","Name":"Consent","IsOption":false,"Order":3,"IsRequired":true,"QuestionText":"I have read and agree to the terms above."}',
                title: '***I have read and agree to the terms above**',
                valueOn: 'True',
                valueOff: 'False',
                value: 'false',
                isRequired: true,
                errorMessage: 'You must agree  before continuing.',
            },
            {
                type: 'TextBlock',
                isSubtle: true,
                text: 'Fields marked with * are mandatory.',
                wrap: true,
            },
        ],
        actions: [
            {
                type: 'Action.Submit',
                title: 'Start Chatting',
                data: {
                    Type: 'InputSubmit',
                },
            },
        ],
    };

    const getAllLcwForLocale = async () => {
        // const urlStr = encodeURIComponent('origin=Official website&sitename=12');
        // console.log(`https://efcrm.ecoflow.com/api/LiveChat/GetAdaptive?${urlStr}`);
        try {
            const originParams = encodeURIComponent('Official website');
            const res = await fetch(
                `https://efcrm.ecoflow.com/api/LiveChat/GetAdaptive?origin=${originParams}&sitename=${localSiteMap[locale] || localSiteMap['us']}`,
            );
            const result = await res.json();
            if (result && Object.keys(result)?.length > 0) {
                setPayloadData(result);
                return;
            }
            setPayloadData(originPlayload);
        } catch (error) {
            console.log('GetAdaptive error--->>>', error);
            setPayloadData(originPlayload);
        }
    };
    useEffect(() => {
        if (NEXT_PUBLIC_MODY === 'prd' || NEXT_PUBLIC_MODY === 'test') {
            const openHandleA = () => {
                const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > 300) {
                    getAllLcwForLocale();
                    window.removeEventListener('scroll', openHandleA);
                    setTimeout(() => {
                        setLoadChat(true);
                    }, 2 * 1000);
                }
            };
            window.addEventListener('scroll', openHandleA);
        }
    }, []);

    return {
        loadChat,
        payloadData,
    };
};
